import { extractParams } from "@zapier/url-utils";
import { isBrowser } from "@zapier/promotions/esm/utils";
export const getOfferIdFromUrl = () => {
    let offerIdFromUrl;
    if (isBrowser()) {
        const { offer_id } = extractParams(window.location.href);
        offerIdFromUrl = offer_id;
    }
    return offerIdFromUrl;
};

// @zapier/upsells@5.0.1 (c64b11b3c)
